<template>
  <div class="button-wrap">
    <svg-icon icon-class="matr1x_fire_play_now" class-name="sign_in" />
    <span class="btn-title">PLAY NOW</span>
  </div>
</template>

<script>

export default {
  data() {
    return {}
  },
  props: {},
  components: { },
  computed: {},
  mounted() { },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>